<template>
    <div class="applyInfo">
      <div class="search">
        <div class="dataTime">
            <van-row class="search">
              <van-col :span="19">
                <!-- <van-search
                  v-model="searchIdNoValue"
                  placeholder="请输入身份证号查询"
                  @input="queryInfo"
                  @search="queryInfo"
                />
                <van-search
                  v-model="searchPlateNoValue"
                  placeholder="请输入车牌号查询"
                  @input="queryInfo"
                  @search="queryInfo"
                /> -->
                <van-search
                  v-model="searchIdNoValue"
                  placeholder="请输入身份证号查询"
                  @clear="queryInfo"
                />
                <van-search
                  v-model="searchPlateNoValue"
                  placeholder="请输入车牌号查询"
                  @clear="queryInfo"
                  @blur="queryInfo"
                />
              </van-col>
                <van-col :span="4" >
                <!-- <van-button type="info" class="queryButton">搜索</van-button> -->
                <van-button plain hairline type="info" class="queryButton" @click="queryInfo">查询</van-button>
              </van-col>
            </van-row>
            <span style="color: #fa8f04;font-weight: bold; font-size: 13px;float: right;margin-right: 5%;">{{ queryDataLength }}</span>
            <!-- <van-divider /> -->
          <!-- <van-row>
            <van-field v-model="searchValue" label="文本" placeholder="请输入用户名" />
          </van-row> -->
          <van-row>
            <van-cell title="查询开始时间：" is-link :value="dataForm.dateBegin" @click="clickBegin(dataForm.dateBegin)" />
            <van-calendar ref="applyInfo" :value="dataForm.dateBegin" v-model="showBegin" :min-date="minDate" :max-date="maxDate" @confirm="onConfirmBegin" />
          </van-row>
          <van-row>
            <van-cell title="查询结束时间：" is-link :value="dataForm.dateEnd" @click="showEnd = true" />
            <van-calendar v-model="showEnd" :min-date="minDate" :max-date="maxDate" @confirm="onConfirmEnd" />
          </van-row>
          <van-divider style="margin: 0;" />
            <!-- <van-row style="margin:0 12px;">
            <van-button round block plain hairline type="info"  @click="onSearch">查 询</van-button>
          </van-row> -->
        </div>
      </div>
      <div class="searchContent">
        <van-list
          :finished="finished"
          finished-text="没有更多了"
        >
        <!-- :title="'身份证号：'+item.idNo" -->
        <!-- <van-cell v-for="item in responseDataArray" :key="item.id"  :title="isPlateNo == true ? `车牌号：${item.plateNo}`:`身份证号：${item.idNo}`">
          <van-button  plain hairline type="info" @click="showDetail(item)">编辑</van-button>
        </van-cell> -->
          <van-cell v-for="item in queryDataArray" :key="item.id" >
            <van-row>
              <van-col :span="18">
                <van-row>
                  <van-col :span="8" style="text-align: right;">车牌号码：</van-col>
                  <van-col :span="16">{{ item.plateNo }}</van-col>
                </van-row>
                <van-row>
                  <van-col :span="8" style="text-align: right;">身份证号：</van-col>
                  <van-col :span="16">{{ item.idNo }}</van-col>
                </van-row>
              </van-col>
              <van-col :span="5">
                <!-- <van-button  plain hairline type="info" @click="showDetail(item)"
                 >编辑</van-button> -->
                <van-button  style="height: 42px;" plain hairline type="info" @click="showDetail(item)"
                 >{{ item.state==0?'编辑':'查看' }}</van-button>
              </van-col>
            </van-row>
          </van-cell>
        </van-list>
      </div>
      <!-- 0.42667rem -->
      <!-- 450881200010058922 -->
      <!-- 编辑申请信息 -->
          <van-overlay :show="showDataDetail" @click="showDataDetail=false">
            <div class="wrapper" @click.stop>
              <div class="applyBlock">
                <van-form>
                  <div class="title">
                  <span>{{ showList.state == 0?'编辑申请信息':'查看申请信息' }}
                    <van-icon name="close" class="cancel" @click="cancelForm"/>
                  </span>
                </div>
                <van-field label="身份证号："  v-model="showList.idNo" :disabled="showList.state == 0 ? false:true" :maxlength="18"/>
                <van-field label="存放位置：" v-model="showList.boxCode" disabled/>
                <van-field label="车牌类型：" :disabled="showList.state == 0 ? false:true">
                  <template #input>
                    <van-radio-group v-model="showList.plateType" direction="horizontal" :disabled="showList.state == 0 ? false:true">
                      <van-radio :name= 0 checked-color="#3399ff">蓝牌</van-radio>
                      <van-radio :name= 1 checked-color="#3399ff">绿牌</van-radio>
                    </van-radio-group>
                  </template>
                </van-field>
                <van-field label="车牌号码：" v-model="showList.plateNo" :disabled="showList.state == 0 ? false:true" :maxlength="8" />
                <van-field label="手机号码：" v-model="showList.phoneNo" :disabled="showList.state == 0 ? false:true" :maxlength="11" />
                <!-- <van-field label="业务受理点："  v-model="showList.applyStation" disabled />
                <van-field label="号牌领取点："  v-model="showList.getStation" disabled /> -->
                <van-row class="stationPicker " :class="{'van-field--disabled':isDisabled}">
                  <van-field
                    readonly
                    clickable
                    label="业务受理点："
                    :value="this.showList.applyStation"
                    placeholder="点击选择业务受理点"
                    @click="showPickers('apply')"
                    :disabled="showList.state == 0 ? false:true"
                  ></van-field>
                  <van-popup v-model="showApplyPicker" round position="bottom" >
                    <van-picker
                      show-toolbar
                      title="下划查看更多服务站"
                      :columns="stationOption"
                      @cancel="showApplyPicker = false"
                      :visible-item-count = 9
                      @confirm="setConfirm"
                      :disabled="showList.state == 0 ? false:true"
                    />
                  </van-popup>
                </van-row>
                <van-divider style="margin: 0;"/>
                <van-row class="stationPicker" :class="{'van-field--disabled':isDisabled}" >
                  <van-field
                    readonly
                    clickable
                    :value="this.showList.getStation"
                    label="号牌领取点："
                    placeholder="点击选择号牌领取点"
                    @click="showPickers('get')"
                    :disabled="showList.state == 0 ? false:true"
                  />
                  <van-popup v-model="showGetPicker" round position="bottom">
                    <van-picker
                      show-toolbar
                      title="下划查看更多服务站"
                      :columns="getPlateOption"
                      @cancel="showGetPicker = false"
                      @confirm="getConfirm"
                      :disabled="showList.state == 0 ? false:true"
                    />
                  </van-popup>
                </van-row>
                <van-divider style="margin: 0;"/>
                <van-field label="申请状态：" v-model="showList.stateDescription" :disabled="showList.state == 0 ? false:true">
                  <template #button>
                    <van-button type="danger" @click="deleteInfo(showList)" :disabled="showList.state == 0 ? false:true">作废</van-button>
                  </template>
                </van-field>
                <van-field label="创建时间： " v-model="showList.createTime" disabled/>
                <!-- <van-field label="照片：" :disabled="showList.state == 0 ? false:true">
                  <template #input>
                    <van-button round block plain hairline type="info" @click="confirmFrom(showList)">
                      确 定</van-button>
                  </template>
                </van-field> -->
                </van-form>
                <van-divider style="margin: 0;"/>
                <div style="margin: 16px;">
                  <van-button round block plain hairline type="info" @click="showPhoto(showList)" v-show="showList.photo==null?false:true">
                    查看照片</van-button>
                  <!-- <van-button round block plain hairline type="info" @click="confirmFrom(showList)" style="margin-top: 10px;">
                    确 定</van-button> -->
                    <van-button round block type="info" @click="confirmFrom(showList)" style="margin-top: 10px;">
                      确 定</van-button>
                </div>
              </div>
            </div>
          </van-overlay>

          <!-- 展示图片 -->
          <!-- <van-popup v-model="show" >
            <van-loading size="30px" type="spinner" color="#1989fa" v-show="loadingImg"></van-loading>
              <van-image
                v-if="!loadingImg"
                width="100%"
                height="100%"
                :src="imgSrc"
              >
                <template v-slot:error>图片加载失败</template>
              </van-image>
          </van-popup> -->
            <van-popup v-model="show" >
            <div class="imgBox">
              <van-loading size="30px" type="spinner" color="#1989fa" v-show="loadingImg"></van-loading>
            <img :src="imgSrc" v-if="!loadingImg" >
            </div>
            </van-popup>
        <!-- 管理员信息 -->
         <!-- <van-overlay :show="confirmShow" @click="confirmShow=false">
          <div class="wrapper" @click.stop>
              <div class="applyBlock" style="height: 40%;">
                <div class="title">
                  <span>管理员信息</span>
                </div>
                <van-row style="margin: 8% 0;">
                  <van-divider />
                  <van-field label="手机号:" v-model="confirmForm.userPhoneNo"
                   type="tel" placeholder="请输入管理员手机号"
                   :rules="[{required:true, pattern: /^1[3456789]\d{9}$/, message: '手机号码格式不正确',}]"
                   />
                   <div></div>
                </van-row>
                <van-row style="margin-top: 8%;">
                  <van-col :span="12">
                    <van-button @click="cancel" plain hairline type="info" class="buttons">取消</van-button>
                  </van-col>
                  <van-col :span="12">
                    <van-button @click="confirm" plain hairline type="info" class="buttons">确认</van-button>
                  </van-col>
                </van-row>
              </div>
            </div>
         </van-overlay> -->
    </div>
  </template>
  
  <script>
  import {QueryApplyInfo,ModifyApplyInfo,QueryApplyPhoto,QueryStationDic} from '@/my_js//HttpRequest.js'
  import {formatTime,getNowTime,formatDateTime,formatBeginTime,formatEndTime} from '@/utils/date.js'
  import { Notify,Dialog } from 'vant'
  import PlateNumber from '../plateNo.vue'
   import store from '@/store/index.js'
  export default {
    components:{
      PlateNumber,
    },
    filters:{
      formatTime:function(inputTime){
       return formatTime(inputTime)
      },
    },
   
    data(){
      return{
        dataForm:{
          id:'',
          applyState:-1,//申请状态
          plateType:-1,//车牌类型
          plateNo:'',//车牌号
          // idNo:'450881200010108922',
          idNo:'',//身份证号
          phoneNo:'',//手机号
          verifyNo:'',//验证码
          userPhoneNo:'',//管理员手机号
          dateBegin:null,//开始时间
          dateEnd:null,//结束时间
        },
        // exitDisable:false,//编辑按钮禁用
        isPlateNo:false,//是否为车牌号
        radio:'1',//1：身份证号查询，2：车牌号查询
        searchIdNoValue:'',//身份证号搜索内容
        searchPlateNoValue:'冀A',//车牌号搜索内容
        // list:[],
        loading:false,
        loadingImg:false,
        finished:false,
        responseDataArray:[],//响应数据
        queryDataArray:[],//查询数据
        showDataDetail:false,//详情显示
        showList:[],//详情信息列表
        confirmShow:false,//修改确认
        // userName:'',//用户名
        confirmForm:{
          userPhoneNo:'',//身份证号
          userName:'',//用户名
        },
        showBegin:false,
        showEnd:false,
        minDate:new Date(2020,0,1),
        maxDate:new Date(2050,12,31),
        show:false,//是否显示图片
        imgSrc:null,//图片 base64 字符串
        zoom:1,
        stationDic:null,//服务站信息
        queryDataLength:null,//查询到的数据量
        selectValue:'',//下拉框默认选择
        showApplyPicker:false,//显示受理下拉
        stationOption:[],//下拉框选项
        getPlateOption:[],//取牌下拉框选项
        showGetPicker:false,//显示取牌下拉
        getPlateAddress:null,//号牌领取点信息,存储石家庄车管所一所的信息
        isDisabled:false,//下拉框禁用
        
      }
    },
    mounted(){
      // this.dataForm.dateBegin = getNowTime()//默认查询当天时间
      // this.dataForm.dateEnd = getNowTime()
      // this.onSearch()
      const end = new Date()
      const start = new Date()
      end.setTime(start.getTime() - 3600 * 1000 * 24 * 7)//默认查询7天时间
      const data = formatDateTime(end)
      console.log(data);
      this.dataForm.dateBegin = data
      this.dataForm.dateEnd = getNowTime()//当天时间
      // this.onSearch()

      // 获取服务站信息
      this.queryStationDic()
      // this.image()

    },
    methods:{
      // 返回
      goBack(){
        console.log('返回管理员首页');
        this.$router.push('/manager')
      },
      // // 搜索
      // onSearch(val){
      //   this.loading = true
      //   console.log('搜索输入内容：',val);
      //   const beginTime = formatBeginTime(this.dataForm.dateBegin)
      //   const endTime = formatEndTime(this.dataForm.dateEnd)
      //   const dataArray = {
      //     id:'',
      //     applyState:-1,//申请状态
      //     plateType:-1,//车牌类型
      //     plateNo:'',//车牌号
      //     idNo:'',//身份证号
      //     phoneNo:'',//手机号
      //     verifyNo:'',//验证码
      //     userPhoneNo:'',//管理员手机号
      //     dateBegin:beginTime,//开始时间
      //     dateEnd:endTime,//结束时间
      //   }
      //   console.log('dataArray:',dataArray);

      //   QueryApplyInfo(dataArray).then(res =>{
      //       console.log(res);
      //       this.responseDataArray = res.data
      //       this.queryDataArray = this.responseDataArray
      //       console.log( 'this.responseDataArray',this.responseDataArray);
      //       this.finished = true
      //       this.loading=false
      //     })
      //   // if(val){
      //   //   if(val.length == 7 || val.length == 8){
      //   //     this.isPlateNo = true
      //   //     dataArray.plateNo = val
      //   //   }else{
      //   //     this.isPlateNo = false
      //   //     dataArray.idNo = val
      //   //   }
      //   //   QueryApplyInfo(dataArray).then(res =>{
      //   //     console.log(res);
      //   //     this.responseDataArray = res.data
      //   //     console.log( 'this.responseDataArray',this.responseDataArray);
      //   //     this.finished = true
      //   //     this.loading=false
      //   //   })
      //   //   this.dataForm.plateNo = ''
      //   //   this.dataForm.idNo = ''
      //   // }else{
      //   //   // this.dataForm.idNo = val
      //   //   // this.isPlateNo = false
      //   //   QueryApplyInfo(dataArray).then(res =>{
      //   //     console.log(res);
      //   //     this.responseDataArray = res.data
      //   //     console.log( 'this.responseDataArray',this.responseDataArray);
      //   //     this.finished = true
      //   //     this.loading=false
      //   //   })
      //   // }
        
      // },
      // 查询数据
      queryInfo(){
        // 将输入的身份证号和车牌号转换为大写
        const formattedIdNo = this.trimmedStr(this.searchIdNoValue).toUpperCase();
        const formattedPlateNo = this.trimmedStr(this.searchPlateNoValue).toUpperCase();
        console.log('formattedIdNo',formattedIdNo);
        console.log('formattedPlateNo',formattedPlateNo);
        

      //   // 优先按照身份证号进行查询
      //  if (formattedIdNo) {
      //     this.queryByIdNo(formattedIdNo);
      //   } else if (formattedPlateNo) {
      //     this.queryByPlateNo(formattedPlateNo);
      //   } else{
      //     console.log('请输入搜索条件');
      //     // this.onSearch()
      //   }

       // 优先按照身份证号进行查询
       if (formattedIdNo) {
          this.queryByIdNo(formattedIdNo);
        } else if (formattedPlateNo) {
          // this.queryByPlateNo(formattedPlateNo);
          if(formattedPlateNo.length <= 2){
            console.log('用户没有输入车牌号');
            // Notify({message:'请输入查询条件后再查询',type:'warning'})
            this.searchPlateNoValue = '冀A'//车牌号搜索内容'
          }else{
            this.queryByPlateNo(formattedPlateNo);
          }
        } else{
          console.log('请输入搜索条件');
          this.queryDataArray = []
          this.searchPlateNoValue = '冀A'//车牌号搜索内容'
        }


      },
      // 身份证号查询
      queryByIdNo(idNo){
         // 根据身份证号查询逻辑
          // const filteredData = this.responseDataArray.filter(item =>
          //   item.idNo.includes(idNo)
          // );
        //   console.log('身份证号查询结果:', filteredData);
        //   // this.queryDataArray = filteredData

        //   if(filteredData.length != 0){
        //   this.queryDataArray = filteredData
        //   console.log('filteredData',this.filteredData);
        // }else{
        //   this.queryDataArray = filteredData
        //   Notify({message:'该身份证号暂无申请信息，请稍后再查询',type:'warning'})
        // }

        const beginTime = formatBeginTime(this.dataForm.dateBegin)
        const endTime = formatEndTime(this.dataForm.dateEnd)
        const dataArray = {
          id:'',
          applyState:-1,//申请状态
          plateType:-1,//车牌类型
          plateNo:'',//车牌号
          idNo:idNo,//身份证号
          phoneNo:'',//手机号
          verifyNo:'',//验证码
          userPhoneNo:'',//管理员手机号
          dateBegin:beginTime,//开始时间
          dateEnd:endTime,//结束时间
        }
        console.log('dataArray:',dataArray);
        QueryApplyInfo(dataArray).then(res =>{
            console.log(res);
           if(res.data.length == 0){
            Notify({message:'查询不到该数据',type:'warning'})
            this.queryDataLength = null
           }else{
            this.queryDataArray = res.data
            this.queryDataLength = this.queryDataArray.length
            console.log( 'this.queryDataArray',this.queryDataArray);
            this.finished = true
            this.loading=false
           }
          })
      },
       // 车牌号查询
       queryByPlateNo(plateNo){
        // // 根据车牌号查询逻辑
        // const filteredData = this.responseDataArray.filter(item =>
        //   item.plateNo.includes(plateNo)
        // );
        // console.log('车牌号查询结果:', filteredData);
        
        // if(filteredData.length != 0){
        //   // this.detailList = boxInfo[0]
        //   // console.log('detailList',this.detailList);
        //   // this.showDataDetail = true
        //   this.queryDataArray = filteredData
        //   console.log('filteredData',this.filteredData);
        // }else{
        //   this.queryDataArray = filteredData
        //   Notify({message:'该车牌号暂无申请信息，请稍后再查询',type:'warning'})
        // }

        const beginTime = formatBeginTime(this.dataForm.dateBegin)
        const endTime = formatEndTime(this.dataForm.dateEnd)
        const dataArray = {
          id:'',
          applyState:-1,//申请状态
          plateType:-1,//车牌类型
          plateNo:plateNo,//车牌号
          idNo:'',//身份证号
          phoneNo:'',//手机号
          verifyNo:'',//验证码
          userPhoneNo:'',//管理员手机号
          dateBegin:beginTime,//开始时间
          dateEnd:endTime,//结束时间
        }
        console.log('dataArray:',dataArray);
        QueryApplyInfo(dataArray).then(res =>{
            console.log(res);
            if(res.data.length == 0){
            Notify({message:'查询不到该数据',type:'warning'})
            this.queryDataLength = null
           }else{
            this.queryDataArray = res.data
            this.queryDataLength = this.queryDataArray.length
            console.log( 'this.queryDataArray',this.queryDataArray);
            this.finished = true
            this.loading=false
           }
          })
       },
      // 去除空格
      trimmedStr(str){
        return str.replace(/\s+/g,'')
      },
      // 编辑
      showDetail(val){
        console.log('val',val);
        this.showDataDetail = true
        val.createTime = formatTime(val.createTime)
        this.showList = val
        if(this.showList.state != 0){
          this.isDisabled = true
        }else{
          this.isDisabled = false
        }
       
        // 业务受理点
        const filterApplyStation = this.stationDic.filter(item => item.code == val.applyStationCode)
        this.showList.applyStation = filterApplyStation[0].name
        // console.log('filterApplyStation',filterApplyStation);
        this.showList.modApplyStationCode = filterApplyStation[0].code
        console.log('1111111111',filterApplyStation);
        // 根据业务受理点选择号牌领取点
        const splitApplyStation = this.splitGetStation(filterApplyStation[0].getStation)
        console.log('splitApplyStation',splitApplyStation);
        for(let i = 0; i < splitApplyStation.length; i++){
          console.log(this.stationDic.filter(item => item.code == splitApplyStation[i]));
          const filterData = this.stationDic.filter(item => item.code == splitApplyStation[i]);
          this.getPlateOption.push({text:filterData[0].name,value:filterData[0].code,getStation:filterData[0].getStation})
          
        }
        


        // 号牌领取点
        const filterGetStation = this.stationDic.filter(item => item.code == val.getStationCode)
        this.showList.getStation = filterGetStation[0].name
        this.showList.modGetStationCode = filterGetStation[0].code
        // console.log('this.showList',this.showList);

      
      },
      // 切割取牌服务站
      splitGetStation(str){
        console.log(str);
        return str.split('|').filter(item => item != '')
      },
       // 获取车牌号
      getPlateNo(data){
          this.showList.plateNo = data
      },
      // 关闭编辑页面
      cancelForm(){
        // 清空搜索信息
        this.searchIdNoValue = ''
        // this.searchPlateNoValue = ''
        this.searchPlateNoValue = '冀A'//车牌号搜索内容'
        this.showDataDetail = false
      },
      // 提交修改数据
      confirmFrom(val){
        // debugger
        console.log(val);
        if(val.state != 0){
          this.showDataDetail = false
          // 清空搜索信息
          this.searchIdNoValue = ''
          this.searchPlateNoValue = '冀A'//车牌号搜索内容'
          // this.queryDataArray = []
          // this.queryDataLength = null
        }else if (val.state == 0){
          // 验证身份证号
          const reg = /(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0[1-9]|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/
          const reg1 = new RegExp(/^[A-Z]\d{7,11}$/)
          if(!reg1.test(val.idNo) && !reg.test(val.idNo)){
            Notify({type:'warning',message:'请输入正确的身份证号'})
            return
          }

          // //普通车车牌校验
          // const carCardP =
          //   /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1}$/;

          // //新能源车牌校验
          // const carCardD =
          //   /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DF]$)|([DF][A-HJ-NP-Z0-9][0-9]{4}$))/;
          // if(!carCardP.test(val.plateNo) && (this.showList.plateType == 0)){
          //   Notify({type:'warning',message:'请输入正确的车牌号',duration:2000})
          //   return
          // }
          // if(!carCardD.test(val.plateNo) && (this.showList.plateType == 1)){
          //   Notify({type:'warning',message:'请输入正确的车牌号',duration:2000})
          //   return
          // }
          // if(this.showList.plateNo.length != 7 && this.showList.plateNo.length != 8){
          //   Notify({type:'warning',message:'请输入正确的车牌号',duration:2000})
          //   return
          // }
          if((this.showList.plateType == 0 && this.showList.plateNo.length != 7) || (this.showList.plateType == 1 && this.showList.plateNo.length != 8)){
            Notify({type:'warning',message:'请输入正确的车牌号码',duration:2000})
            return
          }
          Dialog.confirm({
            title: '提示',
            message: '是否确定修改该用户的信息？',
          })
          .then(() => {
            // on confirm
            // debugger
            console.log('点击了确定');
            const beginTime = formatBeginTime(this.dataForm.dateBegin)
            const endTime = formatEndTime(this.dataForm.dateEnd)
            const dataArray = {
            id:this.showList.id,
            applyState:this.showList.state,
            plateType:this.showList.plateType,
            plateNo:this.showList.plateNo,
            idNo:this.showList.idNo,
            applyStationCode:this.showList.modApplyStationCode,
            getStationCode:this.showList.modGetStationCode,
            // // userPhoneNo:this.confirmForm.userPhoneNo
            dateBegin: beginTime,
            dateEnd: endTime,
            userPhoneNo:store.state.userName
            }   
            console.log('dataArray',dataArray);
            // return
            console.log(JSON.stringify(dataArray));
            ModifyApplyInfo(dataArray).then(res =>{
              console.log('修改申请数据：',res);
              Notify({type:'success',message:'修改'+res.msg})
              this.showDataDetail = false
              // 清空搜索信息
              this.searchIdNoValue = ''
              // this.searchPlateNoValue = ''
              this.searchPlateNoValue = '冀A'//车牌号搜索内容'
            })
          })
          .catch(() => {
            // on cancel
            console.log('点击了取消');
            this.showDataDetail = false
            // 清空搜索信息
            this.searchIdNoValue = ''
            // this.searchPlateNoValue = ''
            this.searchPlateNoValue = '冀A'//车牌号搜索内容'
          });
        }
        
        // // debugger
        // console.log(val);
        // // 验证身份证号
        // const reg = /(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0[1-9]|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/
        // const reg1 = new RegExp(/^[A-Z]\d{7,11}$/)
        // if(!reg1.test(val.idNo) && !reg.test(val.idNo)){
        //   Notify({type:'warning',message:'请输入正确的身份证号'})
        //   return
        // }

        // //普通车车牌校验
				// const carCardP =
				// 	/^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1}$/;

				// //新能源车牌校验
				// const carCardD =
				// 	/^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DF]$)|([DF][A-HJ-NP-Z0-9][0-9]{4}$))/;
        // if(!carCardP.test(val.plateNo) && (this.showList.plateType == 0)){
        //   Notify({type:'warning',message:'请输入正确的车牌号',duration:2000})
        //   return
        // }
        // if(!carCardD.test(val.plateNo) && (this.showList.plateType == 1)){
        //   Notify({type:'warning',message:'请输入正确的车牌号',duration:2000})
        //   return
        // }
        // // ModifyApplyInfo(val).then(res =>{
        // //   console.log('修改数据',res);
        // //   _this.$refs.reset.resetData()//清除车牌号
        // // })
        // this.showDataDetail = false
        // this.confirmShow = true
      },
      // 选择日期并格式化时间
      onConfirmBegin(date){
        this.showBegin = false
        // 格式化时间
        this.dataForm.dateBegin = formatDateTime(date)
        console.log('开始时间：',this.dataForm.dateBegin);
        // this.onSearch()
      },
      // 开始时间定位到 dateBegin
      clickBegin(date){
        this.showBegin = true
        this.$nextTick(() => {
          this.$refs.applyInfo.reset(new Date(date))// 确保日历定位到指定时间
        })
      },
      // 选择日期并格式化时间
      onConfirmEnd(date){
      this.showEnd = false
      // 格式化时间
      this.dataForm.dateEnd = formatDateTime(date)
      console.log('结束时间：',this.dataForm.dateEnd);
      // this.onSearch()
      },
      // 查看照片
      showPhoto(val){
        // debugger
        this.show = true
        this.loadingImg = true
        console.log(val);
        const photoPath = val.photo
        console.log('照片路径：',photoPath);
        QueryApplyPhoto(photoPath).then(res => {
          console.log(res);
          if(res.code == 0){
            // 查询图片成功
            // console.log(res.data);
            // 把返回的 base64 数据拼接上图片格式
            this.imgSrc = "data:image/png;base64,"+ res.data
            // this.show = true
            this.loadingImg = false
            this.image()
          }else{
            Notify({type:'warning',message:res.msg})
          }
        })
      },
      // 图片放大缩小
      image(){
        const content = document.querySelector('.imgBox')//获取需要放大缩小的盒子
        let firstDistance = 0 //存放手指开始放上的时候，两根手指之间的距离
        // 缩放事件的处理
        const getDistance = (start,stop) => {
          // 计算两根手指之间的距离
          return Math.sqrt(Math.pow(Math.abs(start.x - stop.x),2) + Math.pow(Math.abs(start.y - stop.y),2))
        }
        content.addEventListener('touchstart',function(event){
          // 获取第一次触摸的点
          const touches = event.touches
          if(touches.length > 1){// 判断是否是两指
            const events1 = touches[0]
            const events2 = touches[1]
            const one = {
              x:events1.pageX,//第一根手指的横坐标
              y:events1.pageY,//第一根手指的纵坐标
            }
            const two = {
              x:events2.pageX,//第二根手指的横坐标
              y:events2.pageY,//第二根手指的纵坐标
            }
            firstDistance = getDistance(one,two)
          }
        })
        document.addEventListener('touchmove',(event) => {
          const touches = event.touches
          if(touches.length > 1){
            const events1 = touches[0]
            const events2 = touches[1]
            const one = {
              x:events1.pageX,//第一根手指的横坐标
              y:events1.pageY,//第一根手指的纵坐标
            }
            const two = {
              x:events2.pageX,//第二根手指的横坐标
              y:events2.pageY,//第二根手指的纵坐标
            }
            const distance = getDistance(one,two)
            let zoom = distance / firstDistance
            content.style.zoom = this.zoom * zoom
          }
        })
        document.addEventListener('touchend',(event) => {
          this.zoom = content.style.zoom
        })
      },
      // 获取服务站信息
      queryStationDic(){
        // this.stationOption.push({text:'请选择服务站',value:0})
        QueryStationDic().then(res => {
          console.log(res);
          this.stationDic = res.data
          this.stationDic.forEach(element => {
            this.stationOption.push({text:element.name,value:element.code,getStation:element.getStation})
          });
          console.log('服务站信息:',this.stationDic);
          // 取牌服务站
          // this.getPlateAddress = this.stationDic.filter(item => item.code == '130100001001')
          // console.log('石家庄车管所一分所',this.getPlateAddress);
          // this.getPlateOption.push({text:this.getPlateAddress[0].name,value:this.getPlateAddress[0].code,getStation:this.getPlateAddress[0].getStation})
          
        })
      },
      // 作废按钮
      deleteInfo(val){
        console.log(val);
        Dialog.confirm({
            title: '提示',
            message: '是否确认作废该申请？',
          })
          .then(() => {
            // on confirm
            console.log('点击了确定');
            const beginTime = formatBeginTime(this.dataForm.dateBegin)
            const endTime = formatEndTime(this.dataForm.dateEnd)
            const dataArray = {
            id:val.id,
            applyState:-2,
            plateType:val.plateType,
            plateNo:val.plateNo,
            idNo:val.idNo,
            dateBegin: beginTime,
            dateEnd: endTime,
            userPhoneNo:store.state.userName
            }   
            console.log('dataArray',dataArray);
            console.log(JSON.stringify(dataArray));
            return
            ModifyApplyInfo(dataArray).then(res =>{
              console.log('修改申请数据：',res);
              Notify({type:'success',message:'申请作废'+res.msg})
              this.showDataDetail = false
              // 清空搜索信息
              this.searchIdNoValue = ''
              this.searchPlateNoValue = ''
              this.queryDataArray = []
              this.searchPlateNoValue = '冀A'//车牌号搜索内容'
              this.queryDataLength = null
            })
          })
          .catch(() => {
            // on cancel
            console.log('点击了取消');
          });
      },
       // 业务受理点选项发生变化
       setConfirm(val) {
        console.log('用户选择的业务受理点',val);
        this.showApplyPicker = false;
        this.showList.applyStation = val.text
        store.commit('setStation', val)
        this.showList.modApplyStationCode = val.value
        console.log(store.state.stationInfo);
        const data = store.state.stationInfo
        if(data.getStation.length > 13){
          this.getPlateOption.push(data)
        }
        this.setPlateValue = data.text
        // 根据业务受理点显示号牌领取点的选项
        this.getPlateOption = []
        const splitApplyStation = this.splitGetStation(val.getStation)
        console.log('splitApplyStation',splitApplyStation);
        // debugger
        for(let i = 0; i < splitApplyStation.length; i++){
          console.log(this.stationDic.filter(item => item.code == splitApplyStation[i]));
          const filterData = this.stationDic.filter(item => item.code == splitApplyStation[i]);
          this.getPlateOption.push({text:filterData[0].name,value:filterData[0].code,getStation:filterData[0].getStation})
        }
        // 号牌领取点选择，长度为1只能在一所取，长度不等于1，默认选择业务受理点同一个服务站
        if(this.getPlateOption.length == 1){
          this.getConfirm(this.getPlateOption[0])
        }else if(this.getPlateOption.length != 1){
          this.getConfirm(this.getPlateOption[1])
        }
      },
      showPickers(val){
        // console.log(val)
        
        if(this.isDisabled){

        }else if(val == 'apply'){
          this.showApplyPicker = true
        }else if(val == 'get'){
          this.showGetPicker = true
        }
      },
      // 号牌领取点选项发生变化
      getConfirm(val){
        console.log('用户选择的号牌领取点',val);
        // this.getPlateValue = val.text;
        this.showList.getStation = val.text
        this.showGetPicker = false;
        // this.applyMessage.getStationCode = val.value
        store.commit('setGetStationCode',this.getPlateValue)
        this.showList.modGetStationCode = val.value
      },
  
     
    }
  
  }
  </script>
  
  <style lang="scss">
  .applyInfo{
    .dataTime{
      .search{
        display: flex;
        align-items: center; /* 垂直居中 */
        .queryButton{
          border: none;
          width: 100%;
          height: 70px;
          line-height: 30px;
        }
      }
    }
    .searchContent{
      .van-cell__title{
        line-height: 45px;
      }
    }
  
    .van-nav-bar__left{
      left: 0;
    }
    .van-nav-bar .van-icon{
      color: #0283ef;
    }
    .van-nav-bar__text{
      color: #0283ef;
    }
    .van-search__action{
      color: #0283ef;
      font-size: 18px;
    }
  
    .wrapper{
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
    }
    .title{
      margin-top: 3%;
      .cancel{
        float: right;
        margin-right: 3%;
        font-size: 28px;
      }
    }
    .applyBlock{
      width: 98%;
      // height: 68%;
      border-radius: 8px;
      background-color: #fff;
      .van-cell__value{
        text-align: left;
      }
      .van-field__control{
        width: 90%;
      }
      .stationPicker{
      .van-picker__title{
        color: #fa8f04;
        font-weight: bold;
      }
      }
    }
    .picWrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
    }

  .picBlock {
    width: 120px;
    height: 120px;
    background-color: #fff;
  }
  
  }
  .van-dialog__confirm {
    background-color: #0094ff; /* 确认按钮背景色 */
    color: #fff; /* 确认按钮字体颜色 */
  }
  
  </style>